import { useSudoziQuery } from "@src/infrastructure/useSudoziQuery";
import { GetDocumentRoute } from "@src/sudozi-schemas/api-route-schemas";

export const useGetDocument = (
  documentId: string | undefined,
  enabled?: boolean,
) => {
  const {
    data: document,
    isLoading: loading,
    error,
    refetch,
  } = useSudoziQuery({
    route: GetDocumentRoute,
    queryKey: ["GET /api/documents/:documentId", documentId],
    params: { documentId: documentId ?? "" },
    options: {
      enabled: !!documentId && (enabled ?? true),
    },
  });

  return {
    document,
    loading,
    error,
    refetch,
  };
};
